import { render, staticRenderFns } from "./StandardNavigationBullet.vue?vue&type=template&id=545c5fa3"
import script from "./StandardNavigationBullet.vue?vue&type=script&lang=ts"
export * from "./StandardNavigationBullet.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports